import { SirketSelectListItemDto, UserDto } from '@emutabakat-types/anaveri';
import { applicationState } from '@/states/applicationState';
import { connect } from 'react-redux';
import kullaniciModel from '@/states/kullaniciModel';
import { logOut } from '@/helpers/oidcHelper';
import React from 'react';
import { Select } from '@arkas/coreui';
import { User } from 'oidc-client';

const Option = Select.Option;

interface CompanySelectProps {
  user: User;
  currentUser: UserDto;
  sirketList: SirketSelectListItemDto[] | undefined;
  seciliSirket: SirketSelectListItemDto | undefined;
}

interface CompanySelectStates {}

/**
 * CompanySelect Component
 */
class CompanySelect extends React.Component<
  CompanySelectProps,
  CompanySelectStates
> {
  componentDidMount() {
    this.handleGetUserCompanies();
  }

  handleGetUserCompanies() {
    return new Promise(resolve => {
      kullaniciModel
        .getUserCompanies()
        .then(response => {
          if (response.sirketList !== undefined) {
            kullaniciModel.setSeciliSirket(
              response.sirketList.find(p => p.isActive)
            );
          }
          kullaniciModel.setSirketList(response.sirketList);
          resolve();
        })
        .catch(() => {
          logOut();
        });
    });
  }

  handleChange = (ad: string) => {
    const { sirketList } = this.props;
    if (sirketList !== undefined) {
      const seciliSirket = sirketList.find(p => p.ad.toString() === ad);
      if (seciliSirket !== undefined) {
        new Promise((resolve, reject) => {
          kullaniciModel
            .updateActiveCompany(seciliSirket)
            .then(response => {
              kullaniciModel.setSeciliSirket(response.seciliSirket);
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      }
    }
  };
  render() {
    const { currentUser, sirketList, seciliSirket } = this.props;
    if (currentUser.isArkasUser) {
      return (
        <div>
          <Select
            defaultValue={seciliSirket ? seciliSirket.ad : undefined}
            style={{ width: 250 }}
            onChange={this.handleChange}
            key={seciliSirket ? seciliSirket.id.toString() : '0'}
            size="small"
          >
            {sirketList !== undefined
              ? sirketList.map(d => (
                  <Option key={d.id.toString()} value={d.ad.toString()}>
                    {d.ad}
                  </Option>
                ))
              : []}
          </Select>
        </div>
      );
    }
    return (
      <div>
        <b style={{ color: '#fff' }}>{currentUser.musteriUnvani}</b>
      </div>
    );
  }
}

const mapStateToProps = (state: applicationState) => ({
  user: state.oidc.user,
  currentUser: state.kullaniciModel.currentUser,
  sirketList: state.kullaniciModel.sirketList,
  seciliSirket: state.kullaniciModel.seciliSirket
});

export default connect(mapStateToProps)(CompanySelect);
